import React from 'react'
import {
    Handle,
    Position
} from '@xyflow/react';

const initStyle = {
    width: 8,
    height: 20,
    borderRadius: 0,
    background: '#7e8186'
}

function TargetHandle({ id }) {
    return (
        <Handle
            key={id}
            id={id}
            type="target"
            position={Position.Left}
            style={initStyle}
        />
    )
}

export default React.memo(TargetHandle)
